import {handleError} from '../../common/utils/errorHandling';
import httpClient from '../../common/services/httpClient';

interface PersonListingDto {
  readonly id: string;
  readonly name: string;
  readonly surname: string;
}

class PeopleService {
  public async getAllPeople(): Promise<PersonListingDto[]> {
    return handleError(
      () => httpClient.get<PersonListingDto[]>('/people'),
      'Error fetching people:',
      () => []
    );
  }
}

const peopleService = new PeopleService();
export default peopleService;
